import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22provider.tsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../../public/fonts/Dana-Regular.woff%22,%22weight%22:%22400%22,%22style%22:%22regular%22},{%22path%22:%22../../public/fonts/Dana-Medium.woff%22,%22weight%22:%22500%22,%22style%22:%22medium%22},{%22path%22:%22../../public/fonts/Dana-Bold.woff%22,%22weight%22:%22700%22,%22style%22:%22bold%22}],%22variable%22:%22--font-iransans%22}],%22variableName%22:%22iranSans%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'iranSans', 'iranSans Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
